<template>
  <div class="appFooter">
    <button @click.prevent="webRedirection()" type="submit" class="appButtonModel2">Vers site Web</button>
    <br>
    <button @click.prevent="userLogOut()" type="submit" class="appButtonModel2">Déconnexion</button>
  </div>
</template>

<script>
// Désactiver le problème du camel case avec jwt-decode
// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode'
export default {
  components: {
  },
  data: function () {
    return {
      userId: ''
    }
  },
  mounted () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    const decryptedToken = jwt_decode(tokenWithDatas.token)
    this.userId = decryptedToken.userId
  },
  methods: {
    webRedirection () {
      this.$router.push('/')
    },
    userLogOut () {
      localStorage.removeItem('orderPrivilegia')
      localStorage.removeItem('orderPrivilegiaSettings')
      localStorage.removeItem('privilegiaPDFdate1')
      localStorage.removeItem('privilegiaPDFdate2')
      localStorage.removeItem('userPrivilegia')
      localStorage.removeItem('modePrivilegia')
      this.$router.push('/')
      location.reload()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Application/FooterApp.vue